import React from 'react';
import Logo from './Logo';


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { faComments } from '@fortawesome/free-regular-svg-icons';
import { Link } from 'react-scroll';


function NavIcons(props) {
	const colorClass = props.colorMode === 'white' ? 'on-white' : 'on-black';

	return (
		<nav className={`nav-icons ${colorClass}`}>
			<ul>
				<li>
					<Link activeClass="active" to="what" spy={true} smooth={true} duration={500}>
						{props.includeIcons === true && 
							<FontAwesomeIcon icon={faEdit} />
						}
						<span>About</span>
					</Link>
				</li>
				<li>
					<Link activeClass="active" to="when" spy={true} smooth={true} duration={500}>
						{props.includeIcons === true  &&
							<FontAwesomeIcon icon={faClock} />
						}
						<span>Schedule</span>
					</Link>	
				</li>
				{props.includeLogo && 
					<li>
						<Logo />
					</li>
				}
				<li>
					<Link activeClass="active" to="who" spy={true} smooth={true} duration={500}>	
						{props.includeIcons === true  &&
							<FontAwesomeIcon icon={faUserCircle} />
						}
						<span>Coaches</span>
						</Link>
				</li>
				<li>
					<Link activeClass="active" to="how" spy={true} smooth={true} duration={500}>
						{props.includeIcons === true  &&
							<FontAwesomeIcon icon={faComments} />
						}
						<span>Sponsors</span>
					</Link>
				</li>
			</ul>
		</nav>)
}
export default NavIcons;
